import { UrlConstants } from "../url.constants";
export class ApiEhPremiseConstants {
    static URL = UrlConstants.API_V2 + "EhPremise";
    static FUNCTION_GET = "GET";
}
